import { useMutation } from '@tanstack/react-query'

import { createJobSchedule } from '../services/createJobSchedule'

export { useRequeueJobSchedule }

const useRequeueJobSchedule = () => {
  return useMutation({
    mutationFn: createJobSchedule,
  })
}
